import { Input } from "antd";
const { Search } = Input;

const SearchInput = ({ onSearch, value }) => {
  return (
    <>
      <Search
        className="search-icon-right"
        placeholder="Search by name, phone number, or keywords"
        allowClear
        onChange={onSearch}
        value={value}
        // onSearch={onSearch}
      />
    </>
  );
};

export default SearchInput;
